<template>
    <div class="shadow-md p-3 w-full">
      <div :class="estilo">
        <label :class="w" for="">Habilitar Anuncio</label>
        <select id="colorPicker" class="form-select w-44" placeholder="Color" v-model="anuncio.colorTexto">
            <option value="" disabled selected>Color</option>
            <option value="white">Blanco</option>
            <option value="black">Negro</option>
        </select>
        <input type="text" class="form-control w-80" placeholder="Titulo" v-model="anuncio.titulo">
        <textarea type="text" class="form-control w-80" placeholder="Texto" v-model="anuncio.texto"></textarea>
        <select id="colorPicker" class="form-select w-80" placeholder="Color" v-model="anuncio.color">
            <option value="" disabled selected>Color</option>
            <option value="#e3001b">Rojo</option>
            <option value="#afcbd9">Azul</option>
            <option value="#fed500">Amarillo</option>
            <!-- Add more color options here -->
        </select>
        <input id="" type="checkbox" v-model="anuncio.habilitado">
      </div>

      <p class="w-full text-center bg-gray-300 mt-4">Habilitar Paginas</p>

      <div :class="estilo">
        <p :class="w" for="catalogo">Catalogo</p>
        <input id="catalogo" type="checkbox" v-model="catalogo.habilitado">
      </div>
      <div :class="estilo">
        <label :class="w" for="">Carrito</label>
        <input id="" type="checkbox" v-model="carrito.habilitado">
      </div>
      <div :class="estilo">
        <label :class="w" for="">Toma de Pedidos</label>
        <input id="" type="checkbox" v-model="pedidos.habilitado">
      </div>
      <div :class="estilo">
        <label :class="w" for="">Banner de Novedades</label>
        <input id="" type="checkbox" v-model="banner.habilitado">
        <button v-if="banner.habilitado" @click="modalBanner()" class="btn border">editar</button>
      </div>
      <div :class="estilo">
        <label :class="w" for="">Mostrar Carousel</label>
        <input id="" type="checkbox" v-model="mostrarCarousel.habilitado">
      </div>
      <div v-if="mostrarCarousel.habilitado" :class="estilo">
        <label :class="w" for="">Texto Carousel</label>
        <input id="" class="border-2 border-black rounded" type="text" v-model="mostrarCarousel.texto">
      </div>
      <div><button @click="guardarPags()" :disabled="cargando" class="btn btn-success">Guardar</button></div>

      <div v-if="mostrarCarousel.habilitado">
        <p class="w-full text-center bg-gray-300 mt-4">Carousel de Novedades</p>
        <div></div>
        <div class="flex items-center gap-1 flex-wrap">
              <div v-for="(ft, key) in carousel" :key="key">
                <div @click="editarImagen(key)" class="cursor-pointer" v-if="!ft.imagen || !ft.imagen.split('|')[0]">
                  <img
                    class="d-block w-32 h-[70px] object-contain"
                    src="../assets/no-photo.jpg"
                    alt="Imagen del articulo"
                  />
                </div>
                <div v-else @click="editarImagen(key)" class="cursor-pointer">
                  <img
                    v-if="isImage(ft.imagen)"
                    :src="ft.imagen.split('|')[0]"
                    :alt="'Slide '"
                    class="d-block w-32 h-[70px] object-contain"
                  />
                  <video
                    v-else
                    class="d-block w-32 h-[70px] object-contain"
                  >
                    <source :src="ft.imagen.split('|')[0]" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <p>{{ key + 1 }}</p>
                <input type="text" placeholder="Texto.." class="form-control w-32" v-model="ft.aux">
                <div class="flex gap-1 items-center">
                  <label :for="'check' + key">Activo</label>
                  <input :id="'check' + key" type="checkbox" class="form-checkbox" v-model="ft.aux2">
              </div>
              </div>
            </div>
            <div><button @click="guardarCarou()" :disabled="cargando" class="btn btn-warning">Guardar</button></div>
      </div>
    </div>


    <div class="modal" id="cambioImagen">
        <div class="modal-dialog">
          <div class="modal-content">
          
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">Cambio de imagen</h4>
            </div>
            
            <!-- Modal body -->
            <div class="modal-body">
              <div v-if="imagenTemp">
                <img
                    v-if="isImage(imagenTemp)"
                    :src="imagenTemp.split('|')[0]"
                    :alt="'Slide '"
                    class="d-block w-44 max-h-[400px] object-contain"
                  />
                  <video
                    v-else
                    controls
                    class="d-block w-44 max-h-[400px] object-contain"
                  >
                    <source :src="imagenTemp.split('|')[0]" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
              </div>
              <div v-else>
                <div v-if="!this.carousel[keyImg] || !this.carousel[keyImg].imagen || !this.carousel[keyImg].imagen.split('|')[0]">
                  <img
                    class="d-block w-44 max-h-[400px] object-contain"
                    src="../assets/no-photo.jpg"
                    alt="Imagen del articulo"
                  />
                </div>
                <div v-else>
                  <img
                    v-if="isImage(this.carousel[keyImg].imagen)"
                    :src="this.carousel[keyImg].imagen.split('|')[0]"
                    :alt="'Slide '"
                    class="d-block w-44 max-h-[400px] object-contain"
                  />
                  <video
                    v-else
                    controls
                    class="d-block w-44 max-h-[400px] object-contain"
                  >
                    <source :src="this.carousel[keyImg].imagen.split('|')[0]" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
              <p>{{ keyImg + 1 }}</p>
              <input :disabled="cargando" class="mt-2 h-24 w-full border-2 border-dashed border-gray-400 rounded file-input" accept="image/*, video/*" max-size="20MB" type="file" ref="fileInput" @change="onFileChange">
              <p class="text-red-500">Para efectuar el cambio, presione guardar</p>
            </div>
            
            <!-- Modal footer -->
            <div class="modal-footer">
              <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cerrar</button>
              <button class="btn btn-success" :disabled="cargando" @click="guardarImg()">Guardar</button>
              <button class="btn btn-warning" :disabled="cargando" title="doble click" @dblclick="borrarImg()">Borrar Imagen</button>
            </div>
            
          </div>
        </div>
      </div>

    <div class="modal" id="cambioImagenBanner">
        <div class="modal-dialog">
          <div class="modal-content">
          
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">Cambio de imagen</h4>
            </div>
            
            <!-- Modal body -->
            <div class="modal-body">
              <div v-if="imagenTempBanner">
                <img
                    :src="imagenTempBanner"
                    :alt="'Slide '"
                    class="d-block w-44 max-h-[400px] object-contain"
                  />
              </div>
              <div v-else>
                <div v-if="!this.banner || !this.banner.imagen || !this.banner.imagen">
                  <img
                    class="d-block w-44 max-h-[400px] object-contain"
                    src="../assets/no-photo.jpg"
                    alt="Imagen del articulo"
                  />
                </div>
                <div v-else>
                  <img
                    :src="this.banner.imagen.split('|')[0]"
                    :alt="'Slide '"
                    class="d-block w-44 max-h-[400px] object-contain"
                  />
                </div>
              </div>
              <input :disabled="cargando" class="mt-2 h-24 w-full border-2 border-dashed border-gray-400 rounded file-input" accept="image/*" max-size="20MB" type="file" ref="fileInput" @change="onFileChange">
              <p class="text-red-500">Para efectuar el cambio, presione guardar</p>
            </div>
            
            <!-- Modal footer -->
            <div class="modal-footer">
              <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cerrar</button>
              <button class="btn btn-success" :disabled="cargando" @click="guardarImgBanner()">Guardar</button>
            </div>
            
          </div>
        </div>
      </div>



  </template>
  
  <script>
import configService from '@/services/config.service';
import carouselService from '@/services/carousel.service';

  export default {
    data() {
      return {
        estilo: 'flex items-center justify-center gap-1 flex-wrap py-2 border-t',
        w: 'w-56 text-left',
        config: [],
        cats: ["ANUNCIO", "CARRITO", "CATALOGO", "PEDIDOS", "CAROUSEL", 'BANNER'],
        anuncio: {
          habilitado: true,
          texto: '',
          titulo: '',
          color: '',
          colorTexto: ''
        },
        cargando: false,
        carousel: [],
        keyImg: '',
        imagenTemp: null,
        imagenTempBanner: null,
        banner: {
          habilitado: true,
          texto: ''
        },
        catalogo: {
          habilitado: true,
        },
        carrito: {
          habilitado: true,
        },
        mostrarCarousel: {
          habilitado: false,
          texto: ''
        },
        pedidos: {
          habilitado: true,
        },
        cambioFoto: false,
        file: ''
      };
    },
    mounted() {
      this.getConfig()
      this.getCarousel()
    },
    computed: {
    },
    methods: {
      guardarCarou() {
        var car = []
        this.carousel.forEach(x => {
          var c = {
            id: x.id,
            foto: x.foto,
            aux: x.aux ? x.aux : '',
            aux2: x.aux2 ? 1 : 0
          }
          car.push(c)
        })
        this.cargando = true
        carouselService.putCarousel(car)
          .then(() => {
            this.cargando = false
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
          })
          .catch(() => {
            this.cargando = false
            this.$root.alertSuccess = false
            this.$root.isAlertVisible = true
          })
      },
      guardarImg() {
        if (this.cambioFoto) {
          if (this.isImage(this.imagenTemp)) {
            console.log('imagen')
            const formData = new FormData()
            formData.append('file', this.file)
            this.cargando = true
            carouselService.postImagen(this.keyImg + 1, formData) 
              .then(() => {
                this.cargando = false
                this.carousel[this.keyImg].imagen = this.imagenTemp
                this.keyImg = ''
                this.file = null
                this.cambioFoto = false
                this.imagenTemp = ''
                window.$('#cambioImagen').modal('hide')
                this.$root.alertSuccess = true
                this.$root.isAlertVisible = true
              })
              .catch(() => {
                this.cargando = false
                console.log('no se cambio la imagen')
                window.$('#cambioImagen').modal('hide')
                this.$root.alertSuccess = false
                this.$root.isAlertVisible = true
              })
            } else {
              console.log('video')
              const formData = new FormData()
              formData.append('file', this.file)
              carouselService.postVideo(this.keyImg + 1, formData) 
                .then(() => {
                  this.carousel[this.keyImg].imagen = this.imagenTemp
                  this.keyImg = ''
                  this.file = null
                  this.cambioFoto = false
                  this.imagenTemp = ''
                  window.$('#cambioImagen').modal('hide')
                  this.$root.alertSuccess = true
                  this.$root.isAlertVisible = true
                })
                .catch(() => {
                  console.log('no se cambio la imagen')
                  window.$('#cambioImagen').modal('hide')
                  this.$root.alertSuccess = false
                  this.$root.isAlertVisible = true
                })
            }
        } else {
          window.$('#cambioImagen').modal('hide')
        }
      },
      guardarImgBanner() {
        console.log('banner')
        console.log(this.cambioFoto)
        if (this.cambioFoto) {
          console.log('imagen')
          const formData = new FormData()
          formData.append('file', new Blob([this.file], { type: 'image/gif' }))
          this.cargando = true
          configService.postBanner(formData) 
            .then(() => {
              this.cargando = false
              this.banner.imagen = this.imagenTemp
              this.file = null
              this.cambioFoto = false
              this.imagenTemp = ''
              window.$('#cambioImagenBanner').modal('hide')
              this.$root.alertSuccess = true
              this.$root.isAlertVisible = true
            })
            .catch(() => {
              this.cargando = false
              console.log('no se cambio la imagen')
              window.$('#cambioImagenBanner').modal('hide')
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
            })
        } else {
          window.$('#cambioImagenBanner').modal('hide')
        }
      },
      modalBanner() {
        window.$('#cambioImagenBanner').modal('show')
      },
      onFileChange(e) {
        const fileInput = e.target.files[0];
        this.file = fileInput

        // Check if the selected file is smaller than the maximum size (5 MB)
        if (fileInput.size > 20 * 1024 * 1024) {
          alert('La imagen es muy grande, el archivo debe ser menor a 20 MB.');
          this.file = null
          return;
        }

        // Check if it's an image or video based on MIME type
        const isImage = fileInput.type.startsWith('image/');
        const isVideo = fileInput.type.startsWith('video/');

        if (!isImage && !isVideo) {
          alert('Por favor, selecciona un archivo de imagen o video.');
          this.file = null
          return;
        }

        const reader = new FileReader();
        reader.onload = () => {

          // Create a Blob URL based on the MIME type
          const blobUrl = URL.createObjectURL(fileInput);
          const formattedUrl = `${blobUrl}|${isImage ? 'image' : 'video'}`;

          // Now you can use 'formattedUrl' as needed, for example, assign it to a Vue data property
          this.imagenTemp = formattedUrl;
        };

        // Read the file as a data URL
        reader.readAsDataURL(fileInput);
        this.cambioFoto = true
      },
      editarImagen(key) {
        this.keyImg = key
        window.$('#cambioImagen').modal('show')
      },
      getCarousel() {
        carouselService.getCarousel()
          .then((res) => {
            this.carousel = res.data
            this.carousel.forEach(x => {
              x.aux2 = (x.aux2 == 1)
              x.aux = (x.aux ? x.aux : '')
            })
            this.cargarFotosCarousel()
          })
          .catch((err) => {
            console.log(err)
          })
      },
      cargarFotosCarousel() {
        for (var i = 1; i < 11; i++ ) {
          this.getFotos(i)
        }
      },
      isImage(url) {
        return url && url.endsWith("image");
      },
      getFotos(i) {
        carouselService.getFotos(i)
          .then(res => {
            const contentType = res.headers["content-type"];

            if (
              contentType && (contentType.startsWith("image/") || contentType.startsWith("video/"))) {
              const mediaBlob = new Blob([res.data], { type: contentType });
              const mediaObjectURL = URL.createObjectURL(mediaBlob);
              const blobUrlWithExtension = `${mediaObjectURL}|${
                contentType.startsWith("image/") ? "image" : "video"
              }`;
                this.carousel[i - 1].imagen = blobUrlWithExtension
            } else {
                this.carousel[i - 1].imagen = ('.' + i);
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      guardarPags() {
        var config = [
          {
            clave: 'ANUNCIO',
            valor: this.anuncio.titulo +';'+ this.anuncio.texto + '|' + this.anuncio.colorTexto + ';'+this.anuncio.color,
            aux: this.anuncio.habilitado ? 1 : 0
          },
          {
            clave: 'CATALOGO',
            valor: '',
            aux: this.catalogo.habilitado ? 1 : 0
          },
          {
            clave: 'CARRITO',
            valor: '',
            aux: this.carrito.habilitado ? 1 : 0
          },
          {
            clave: 'PEDIDOS',
            valor: '',
            aux: this.pedidos.habilitado ? 1 : 0
          },
          {
            clave: 'BANNER',
            valor: this.banner.valor,
            aux: this.banner.habilitado ? 1 : 0
          },
          {
            clave: 'CAROUSEL',
            valor: this.mostrarCarousel.texto ? this.mostrarCarousel.texto : '',
            aux: this.mostrarCarousel.habilitado ? 1 : 0
          }
        ]
        this.cargando = true
        configService.guardarPags(config)
          .then(() => {
            this.cargando = false
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
          })
          .catch((err) => {
            console.log(err)
            this.cargando = false
            this.$root.alertSuccess = false
            this.$root.isAlertVisible = true
          })
      },
      getBanner() {
        configService.getBanner()
          .then((res) => {
            const mediaBlob = new Blob([new Uint8Array(res.data)], { type: 'image/gif' });
            this.banner.imagen = URL.createObjectURL(mediaBlob);
          })
          .catch(err => {
            console.log(err)
          })
      },
      getConfig() {
        configService.getUtils()
          .then((res) => {
            this.config = res.data
            this.cats.forEach(x => {
              if (x == 'CAROUSEL') {
                var q = this.config.find(c => c.clave == x)
                this.mostrarCarousel.texto = q.valor
                configService.getCarousel()
                  .then((res) => {
                    this.mostrarCarousel.habilitado = res.data == 1
                  })
                  .catch(err => {
                    console.log(err)
                  })
              }
              if (x == 'BANNER') {
                q = this.config.find(c => c.clave == x)
                this.banner.habilitado = q.aux == 1 ? true : false
                this.getBanner()
              }
              if (x != 'ANUNCIO') {
                q = this.config.find(c => c.clave == x)
                this[x.toLowerCase()].habilitado = q.aux == 1 ? true : false
              } else {
                q = this.config.find(c => c.clave == x)
                this[x.toLowerCase()].titulo = q.valor.split(";")[0]
                this[x.toLowerCase()].texto = q.valor.split(";")[1].split('|')[0]
                this[x.toLowerCase()].colorTexto = q.valor.split(";")[1].split('|')[1]
                this[x.toLowerCase()].color = q.valor.split(";")[2]
                this[x.toLowerCase()].habilitado = q.aux == 1 ? true : false
              }
            })
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    
  };
  </script>

